import React from "react";
import { Box, Typography } from "@mui/material";
import SkillSheetMainSummaryMobile from "./SkillSheetMainSummaryTable/SkillSheetMainSummaryMobile";
import SkillSheetMainSummaryDesktop from "./SkillSheetMainSummaryTable/SkillSheetMainSummaryDesktop";
import ActionButton from "../../shared/ActionButton";
import { buildWorkHistoryDisplayValues } from "./SkillSheetMainSummaryTable/buildWorkHistoryDisplayValues";
import ExpandableSection from "../ExpandableSection";
import SkillSheetMainDetailDesktop from "./SkillSheetMainDetail/SkillSheetMainDetailDesktop";
import SkillSheetMainDetailMobile from "./SkillSheetMainDetail/SkillSheetMainDetailMobile";
import {
  PROJECT_COLOR,
  PROJECT_COLOR_DARK,
  GRAY_COLOR,
  GRAY_COLOR_DARK,
} from "../../../constants/colors";
import { FONT_SIZE } from "../../../constants/fontSizes";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

/** ===== メイン ===== */
export default function SkillSheetMainList({
  workHistories = [],
  phases = [
    { key: "requirement_definition", label: "要件\n定義" },
    { key: "basic_design", label: "基本\n設計" },
    { key: "detail_design", label: "詳細\n設計" },
    { key: "program", label: "製造\n構築" },
    { key: "test", label: "テス\nト" },
    { key: "maintenance_operation", label: "保守\n運用" },
  ],
  onEdit,
  onDelete,
  showEditButton,
}) {
  const isDesktop = useIsDesktop();

  const buttonBaseSx = {
    height: 28,
    minWidth: 96,
    width: "auto",
    fontSize: FONT_SIZE.SM,
    boxShadow: "none",
    pr: isDesktop ? 3 : 2,
    pl: isDesktop ? 2.5 : 1.5,
  };

  if (!workHistories.length) {
    return (
      <Typography sx={{ color: GRAY_COLOR }}>
        プロジェクトが未登録です
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      {workHistories.map((workHistory) => {
        const displayValues = buildWorkHistoryDisplayValues(workHistory);

        return (
          <Box key={workHistory.id}>
            {/* ===== 上部アクション（スマホは2分割） ===== */}
            {showEditButton ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: isDesktop ? "flex-end" : "space-between",
                  gap: isDesktop ? 1.5 : 1,
                  mb: 1.5,
                }}
              >
                <ActionButton
                  label="編集する"
                  showArrow
                  onClick={() => onEdit?.(workHistory.id)}
                  sx={{
                    ...buttonBaseSx,
                    backgroundColor: PROJECT_COLOR,
                    "&:hover": { backgroundColor: PROJECT_COLOR_DARK },
                    width: isDesktop ? "auto" : "50%",
                    height: 32,
                    minWidth: isDesktop ? 96 : 0,
                  }}
                />

                <ActionButton
                  label="削除する"
                  showArrow
                  onClick={() => onDelete?.(workHistory.id)}
                  sx={{
                    ...buttonBaseSx,
                    backgroundColor: GRAY_COLOR,
                    "&:hover": { backgroundColor: GRAY_COLOR_DARK },
                    width: isDesktop ? "auto" : "50%",
                    height: 32,
                    minWidth: isDesktop ? 96 : 0,
                  }}
                />
              </Box>
            ) : null}
            {/* ===== 本体：スマホは縦、PCは横 ===== */}
            {isDesktop ? (
              <ExpandableSection
                collapsedContent={
                  <SkillSheetMainSummaryDesktop
                    workHistory={workHistory}
                    displayValues={displayValues}
                    phases={phases}
                  />
                }
                expandedContent={
                  <SkillSheetMainDetailDesktop
                    workSections={displayValues.workSections}
                    skillSections={displayValues.skillSections}
                    displayValues={displayValues}
                  />
                }
                summaryText="プロジェクト詳細を見る"
                closeText="プロジェクト詳細を閉じる"
                expandedSpacing={1}
              />
            ) : (
              <ExpandableSection
                collapsedContent={
                  <SkillSheetMainSummaryMobile
                    workHistory={workHistory}
                    displayValues={displayValues}
                    phases={phases}
                  />
                }
                expandedContent={
                  <SkillSheetMainDetailMobile
                    workSections={displayValues.workSections}
                    skillSections={displayValues.skillSections}
                    displayValues={displayValues}
                  />
                }
                summaryText="プロジェクト詳細を見る"
                closeText="プロジェクト詳細を閉じる"
                expandedSpacing={1}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
